<template>
  <div class="ml-3 mb-3">
    <div v-for="(label, key) in labels" :key="key" style="display: inline-block; width: 250px;" class="">
      <div style="display: inline-block; width: 30px; height: 10px" :class="label.bgColor">
        <i :class="label.icon"></i>
      </div>
      <div class="ml-2" style="display: inline-block; font-size: 9pt">
        {{label.label}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount() {},
  data () {
    return {
      isUserRoot: $store.getters['user-state/isUserRoot'],
      isUserPlatformEmployee: $store.getters['user-state/isUserPlatformEmployee'],
      labels: [
        {
          label: 'Missing CDR Details',
          bgColor: 'app-bg-gold-low-alfa',
          icon: ''
        },
        {
          label: 'Portal Access Error',
          bgColor: 'app-bg-red-low-alfa',
          icon: ''
        },
      ]
    }
  }
}
</script>
